export default __webpack_public_path__ + "static/media/pie_chart_placeholder.ffad905b.svg";